(function($) {
	var paramMapping = {
		'params':
		[
			{
				'qv': 'utm_medium',
				'gf': 'lci-medium',
				'key': 'medium'
			},
			{
				'qv': 'utm_source',
				'gf': 'lci-source',
				'key': 'source'
			},
			{
				'qv': 'utm_campaign',
				'gf': 'lci-campaign',
				'key': 'campaign'
			},
			{
				'gf': 'lci-referrer',
				'key': 'referrer'
			}
		]
	};

	var lciMetrics = {};

	function getUrlParameter( name ) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		var results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	};

	function findGFfromKey( key ) {
		for ( var i = 0; i < paramMapping.params.length; ++i ) {
			if ( paramMapping.params[i].key === key ) {
				return paramMapping.params[i].gf;
			}
		}

		return false;
	}

	$( document ).ready( function() {
		if ( typeof( localStorage.lci_metrics ) !== 'undefined' ) {
			lciMetrics = JSON.parse( localStorage.lci_metrics );
		}

		for ( var i = 0; i < paramMapping.params.length; ++i ) {
			var thisValue = false;

			if ( paramMapping.params[i].hasOwnProperty( 'qv' ) ) {
				thisValue = getUrlParameter( paramMapping.params[i].qv );
			}
			else if ( paramMapping.params[i].gf === 'lci-referrer' ) {
				if ( document.referrer.search( window.location.host ) === -1 ) {
					thisValue = document.referrer;
				}
			}

			if ( thisValue !== null && thisValue.length > 0 ) {
				lciMetrics[paramMapping.params[i].key] = thisValue;
			}
		}

		localStorage.lci_metrics = JSON.stringify( lciMetrics );

		for ( var p in lciMetrics ) {
			var gf = findGFfromKey( p );

			if ( gf ) {
				$( '.' + gf ).find( 'input' ).val( lciMetrics[p] );
			}
		}
	});
})( jQuery );